module.exports = __webpack_public_path__ + "img/lot_ico2.bd0a88ca.png";